export default "__VITE_ASSET__BY04YhYo__"